'use strict';

(function () {
	let rootSelector = '[data-lvz-product-features]';
	let slotSelector = '[data-lvz-product-features-slot="true"]';
	let toggleSelector = '[data-lvz-product-features-toggle]';
	let labelSelector = '[data-lvz-product-features-toggle-label]';
	let extraRowSelector = '[data-lvz-product-features-extra="true"]';
	let initializedAttribute = 'data-lvz-product-features-initialized';
	let scrollContainerSelector = '.sa-right-panel-html';
	let headerOffsetSelectors = ['#lvz-top-banner', '#lvz-header-template'];

	/**
	 * Returns the bottom edge of visible sticky header elements.
	 *
	 * @returns {number}
	 */
	function getHeaderOffset() {
		return headerOffsetSelectors.reduce(function (maxBottom, selector) {
			let element = document.querySelector(selector);

			if (!element) {
				return maxBottom;
			}

			let rect = element.getBoundingClientRect();

			if (rect.height < 1 || rect.bottom <= 0) {
				return maxBottom;
			}

			return Math.max(maxBottom, rect.bottom);
		}, 0);
	}

	/**
	 * Finds the nearest scrollable ancestor for a product features block.
	 *
	 * @param {HTMLElement} root - Product features root element.
	 * @returns {HTMLElement|null}
	 */
	function getScrollContainer(root) {
		let node = root.parentElement;

		while (node && node !== document.body) {
			let style = window.getComputedStyle(node);

			if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight) {
				return node;
			}

			if (node.matches && node.matches(scrollContainerSelector)) {
				return node;
			}

			node = node.parentElement;
		}

		return null;
	}

	/**
	 * Scrolls the page or drawer container to the top of a product features block.
	 *
	 * @param {HTMLElement} root - Product features root element.
	 * @returns {void}
	 */
	function scrollToSectionStart(root) {
		let container = getScrollContainer(root);

		if (container) {
			let containerRect = container.getBoundingClientRect();
			let rootRect = root.getBoundingClientRect();
			let destination = container.scrollTop + (rootRect.top - containerRect.top);

			container.scrollTo({
				top: Math.max(0, destination),
				behavior: 'smooth'
			});
			return;
		}

		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let destination = root.getBoundingClientRect().top + scrollTop - getHeaderOffset();

		window.scrollTo({
			top: Math.max(0, destination),
			behavior: 'smooth'
		});
	}

	/**
	 * Updates the expanded/collapsed state for a product features block.
	 *
	 * @param {HTMLElement} root - Product features root element.
	 * @param {boolean} expanded - Whether the list should be expanded.
	 * @returns {void}
	 */
	function setExpanded(root, expanded) {
		let toggle = root.querySelector(toggleSelector);
		let label = toggle ? toggle.querySelector(labelSelector) : null;
		let extraRows = root.querySelectorAll(extraRowSelector);
		let labelText = toggle ? toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more') : '';

		root.classList.toggle('lvz-product-features--expanded', expanded);

		if (toggle) {
			toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		}

		if (label && labelText) {
			label.textContent = labelText;
		}

		Array.prototype.forEach.call(extraRows, function (row) {
			row.hidden = !expanded;
			row.setAttribute('aria-hidden', expanded ? 'false' : 'true');
			row.classList.toggle('lvz-product-features__row--hidden', !expanded);
		});
	}

	/**
	 * Initializes one product features block.
	 *
	 * @param {HTMLElement} root - Product features root element.
	 * @returns {void}
	 */
	function initProductFeatures(root) {
		let toggle = root.querySelector(toggleSelector);

		if (!toggle || root.getAttribute(initializedAttribute) === 'true') {
			return;
		}

		root.setAttribute(initializedAttribute, 'true');
		setExpanded(root, false);

		toggle.addEventListener('click', function () {
			let wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
			let expanded = !wasExpanded;

			setExpanded(root, expanded);

			if (wasExpanded) {
				window.requestAnimationFrame(function () {
					scrollToSectionStart(root);
				});
			}
		});
	}

	/**
	 * Initializes all product features blocks on the page.
	 *
	 * @returns {void}
	 */
	function initAllProductFeatures() {
		let blocks = document.querySelectorAll(rootSelector);

		Array.prototype.forEach.call(blocks, initProductFeatures);
	}

	/**
	 * Replaces the PDP product features slot with the selected letiant HTML.
	 *
	 * @param {Event} e - jQuery event.
	 * @param {Object} response - `product:afterAttributeSelect` payload.
	 * @returns {void}
	 */
	function onAfterAttributeSelect(e, response) {
		let html = response && response.data && response.data.product && response.data.product.productFeaturesHtml;
		let pdp = response && response.container && response.container.closest('.product-detail')[0];
		let slot = pdp ? pdp.querySelector(slotSelector) : null;

		if (typeof html !== 'string' || !slot) {
			return;
		}

		slot.innerHTML = html;
		Array.prototype.forEach.call(slot.querySelectorAll(rootSelector), initProductFeatures);
	}

	if (window.jQuery) {
		window
			.jQuery('body')
			.off('product:afterAttributeSelect.lvzProductFeatures')
			.on('product:afterAttributeSelect.lvzProductFeatures', onAfterAttributeSelect);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllProductFeatures);
	} else {
		initAllProductFeatures();
	}
})();
